import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const HiddenTextArea = ({ prefix, postfix, canChange, value, onChange }) => {
  const [input, setInput] = useState(value);
  const [errors, setErrors] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setInput(value);
  }, [value]);

  const handleChange = ({ target: { value } }) => {
    if (errors) {
      setErrors(false);
    }

    setInput(value);
  };

  const handleBlur = () => {
    setOpen(false);
    onChange(input);
  };

  const handleClick = (e) => {
    if (canChange) {
      e.stopPropagation();
      !open && setOpen(true);
    }
  };

//   if (!open) {
//     return (
//       <div onClick={handleClick} style={{padding:'8px'}}>
//         {prefix}
//         {value}
//         {postfix}
//       </div>
//     );
//   }

  const errorBorder = errors && { border: '1px solid red' };

  return (
    <textarea
      placeholder={prefix}
      className="hidden-textarea"
      value={input}
      style={errorBorder || {}}
      onClick={handleClick}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

HiddenTextArea.propTypes = {
  canChange: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  prefix: PropTypes.string,
  postfix: PropTypes.string,
};

HiddenTextArea.defaultProps = {
  canChange: true,
  onChange: () => {},
  prefix: '',
  postfix: '',
};

export { HiddenTextArea };
